import { RowNode } from 'ag-grid-community';
import { AgGridColumn } from 'ag-grid-react/lib/agGridColumn';
import React, { useEffect, useState } from 'react';
import { EnvelopeFill, FileText, PersonFill } from 'react-bootstrap-icons';
import { useSelector } from 'react-redux';
import { tenancyFeatureSelector } from '../redux/selectors';
import { useHistory } from 'react-router-dom';
import { ConnectedHcpGridWithGQL, FilterInterface, HCPDatePickerWithTime, PatientsFilters, StatusDescription } from '.';
import { usePatientInfoQuery, usePatientRequestInfoQuery, usePatientStatusesQueryQuery } from '../graphql';
import {
  ActionColumnActions,
  actionsColumnDefinition,
  alertColumnDefinition,
  authorizationReceivedFormatter,
  featureGridColumnsSelector,
  getFeatureGridColumnProps,
  idColumnDefinition,
  nextStepColumnWithoutTooltip,
  nameColumnDefinition,
  prescriberColumnDefinition,
  patientHubStatusColumnDefinition,
  ROUTE_PATHS,
  filterGridComparator,
  dobDateColumnFormat,
  dateColumnDefinition,
  rxAdminColumnWithTooltip,
  getConfigurationDataKey,
  generalColumnDefinition
} from '../utils';
import { AnyType, Breadcrumb } from '../interfaces';
import { GridFilters } from './GridFilters';
import { RxAdminDropdownIcon } from './custom-icons';

interface PatientsTableProps {
  enableExternalFilters?: boolean;
  filteredStatus?: string;
}

const columnSelector = featureGridColumnsSelector(getConfigurationDataKey('patients.table'));

export const PatientsTable = (props: PatientsTableProps) => {
  const [gridFilter, setGridFilter] = useState<FilterInterface>({ strictCompare: false });
  const patientsFilterMapping: AnyType = useSelector<AnyType>(tenancyFeatureSelector('patients.filters_v1.5'));
  const [filter, setFilter] = useState<string>();
  const [filterList, setFilterList] = useState<Set<string>>(new Set([]));
  const [statusDescriptions, setStatusDescriptions] = useState<StatusDescription[]>([]);

  const columns = useSelector(columnSelector);
  const history = useHistory();

  useEffect(() => {
    setGridFilter({ ...gridFilter, secondaryFilterList: filterList, primaryFilter: filter });
  }, [filterList, filter]);

  if (!columns) return null;

  const goToPatientDetails = (params: any) => {
    history.push(`${ROUTE_PATHS.patients}/${params.data.patientId}#summary`);
  };
  const filterProps = props.enableExternalFilters
    ? {
        isFilterActive: true,
        filterComparator: function (node: RowNode, filter?: FilterInterface) {
          return filterGridComparator(node, filter, patientsFilterMapping);
        },
        filterValue: gridFilter
      }
    : {};

  return (
    <div>
      {props.enableExternalFilters && (
        <GridFilters
          onFilterChange={(filter: string) => setFilter(filter)}
          isPatientsView={true}
          hideDropDownFilter={columns?.patientHubStatus?.hide}
        />
      )}
      <div className='site-background'>
        <ConnectedHcpGridWithGQL
          className='grid-wrapper'
          descriptionType='PatientStatusDescription'
          {...filterProps}
          queryHook={usePatientRequestInfoQuery}
          onDataLoad={(statusDescriptions: StatusDescription[]) => setStatusDescriptions(statusDescriptions)}
          pagination>
          {/* <AgGridColumn {...alertColumnDefinition()} onCellClicked={goToPatientDetails} /> */}
          <AgGridColumn
            field='lastName'
            resizable={true}
            {...generalColumnDefinition()}
            {...nameColumnDefinition(columns.lastName)}
            onCellClicked={goToPatientDetails}
          />
          <AgGridColumn
            {...generalColumnDefinition()}
            field='firstName'
            resizable={true}
            {...nameColumnDefinition(columns.firstName)}
            onCellClicked={goToPatientDetails}
          />
          <AgGridColumn
            {...generalColumnDefinition()}
            {...dobDateColumnFormat('dob')}
            resizable={true}
            // {...getFeatureGridColumnProps(columns.dob)}
            onCellClicked={goToPatientDetails}
          />
          <AgGridColumn
            {...generalColumnDefinition()}
            resizable={true}
            {...idColumnDefinition('patientId')}
            // {...getFeatureGridColumnProps(columns.id)}
            onCellClicked={goToPatientDetails}
          />
          <AgGridColumn
            {...generalColumnDefinition()}
            resizable={true}
            field='Consent'
            filterValueGetter={authorizationReceivedFormatter}
            valueFormatter={authorizationReceivedFormatter}
            valueGetter={authorizationReceivedFormatter}
            {...getFeatureGridColumnProps(columns.consent)}
            onCellClicked={goToPatientDetails}
          />
          <AgGridColumn
            resizable={true}
            {...generalColumnDefinition()}
            {...prescriberColumnDefinition()}
            {...getFeatureGridColumnProps(columns.prescriber)}
            onCellClicked={goToPatientDetails}
          />
          <AgGridColumn
            resizable={true}
            {...generalColumnDefinition()}
            {...patientHubStatusColumnDefinition(
              'patientHubStatus',
              columns.patientHubStatus.headerName,
              patientsFilterMapping
            )}
            {...getFeatureGridColumnProps(columns.patientHubStatus)}
            onCellClicked={goToPatientDetails}
          />
        </ConnectedHcpGridWithGQL>
      </div>
    </div>
  );
};
